export const sortArrayByNameProperty = (a: { name: string }, b: { name: string }) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0);